export enum WorlogWeeksDaysFilters {
  CALENDAR_WEEK = "Calendar Week",
  WORKDAYS = "Workdays",
}
